import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
/* -------------------------------------------------------------------------------------------------
 * CardViewSwitcher
 * ----------------------------------------------------------------------------------------------- */
const CARD_VIEW_SWITCHER_NAME = 'CardViewSwitcher';
const CARD_VIEW_SWITCHER_ITEM = 'CardViewSwitcherItem';
export const CARD_VIEW_LIST = 'list';
export const CARD_VIEW_GRID = 'grid';
const CardViewSwitcher = React.forwardRef(({ defaultValue = CARD_VIEW_GRID, onValueChange = () => { }, ...props }, forwardedRef) => {
    const [cardViewValue, setCardViewValue] = useState(defaultValue);
    const onToggle = useCallback((value) => {
        if (value) {
            setCardViewValue(value);
            onValueChange(value);
        }
    }, [setCardViewValue, onValueChange]);
    return (_jsx(ToggleGroupPrimitive.Root, { type: "single", value: cardViewValue, onValueChange: onToggle, ref: forwardedRef, ...props }));
});
CardViewSwitcher.displayName = CARD_VIEW_SWITCHER_NAME;
const CardViewSwitcherItem = React.forwardRef((props, forwardedRef) => {
    const { children, value, ...itemProps } = props;
    return (_jsx(ToggleGroupPrimitive.Item, { value: value, ...itemProps, ref: forwardedRef, children: children }));
});
CardViewSwitcherItem.displayName = CARD_VIEW_SWITCHER_ITEM;
const Root = CardViewSwitcher;
const Item = CardViewSwitcherItem;
export { Root, Item };
